export default "__VITE_ASSET__DPcIzEuf__"